import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FloatLabelModule } from 'primeng/floatlabel';


@Component({
  selector: 'prime-float-label',
  standalone: true,
  imports: [
    NgClass,
    FloatLabelModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './prime-float-label.component.html',
  styleUrl: './prime-float-label.component.scss'
})
export class PrimeFloatLabelComponent {
  label = input.required<string>();
  classes = input<string>();
  inputId = input<string>();
}
